export const ValidURLSlug = /[^a-zA-Z-_\d]/gi;
export const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
